/* eslint-disable react/jsx-max-depth */
import React, { createContext } from "react";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApolloProvider } from "@apollo/client";
import { CssBaseline } from "@mui/material";
import client from "apollo/client";
import { ClickToComponent } from "click-to-react-component";
import { CubeProvider } from "@cubejs-client/react";
import { RecoilRoot } from "recoil";
import "./App.css";
import StartupOperations from "components/organisms/StartupOperations";
import MetaDecorator from "components/templates/MetaDecorator";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { RecoilDevTools, RecoilTunnel } from "recoil-toolkit";
import { useCustomThemeManager, themes } from "@mlpa/shared-ui-core-theme";

import cubejsApi from "pages/SecurityCenter/cube/cubejsApi";
import Router from "./routes/Router";
import { LicenseInfo } from "@mui/x-license";
import { AuthenticationCompontent } from "authentication";
import ThemeProviderOO from "@mlpa/shared-ui-core-theme";

import { getBrandingConfig } from "authentication/runtimeConfig";
import AppContainers from "./AppContainers";

//eslint-disable-next-line react/jsx-max-depth
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_DATAGRID_KEY ?? "");
export const ColorModeContext = createContext({ toggleColorMode: () => {} });

const FALLBACK_THEME_MODE: ThemeMode = "knorr-light";

type ThemeMode = keyof typeof themes;

/**
 * Guard against runtime configs (config.js) that request a theme mode the
 * theme package doesn't ship. themes[unknownMode] is undefined, which makes
 * MUI fall back to a default theme without custom palette groups and crashes
 * any component reading e.g. theme.palette.additional.* (Sidebar).
 */
const resolveThemeMode = (mode: string): ThemeMode => {
  if (mode in themes) return mode as ThemeMode;
  console.warn(`[Theming] Unknown theme mode "${mode}". Falling back to "${FALLBACK_THEME_MODE}".`);
  return FALLBACK_THEME_MODE;
};

const AppInner = () => {
  const { colorMode } = useCustomThemeManager();
  const branding = getBrandingConfig();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProviderOO mode={resolveThemeMode(branding.themeMode)}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AuthenticationCompontent>
            <StartupOperations>
              <CssBaseline />
              <MetaDecorator />
              <ClickToComponent />
              <AppContainers />
              <Router />
              <RecoilTunnel />
              {import.meta.env.DEV && (
                <RecoilDevTools
                  forceSerialize
                  serializer={(obj: unknown) => {
                    return JSON.stringify(obj, (key, value) => {
                      if (Object.hasOwn(value ?? {}, "$$typeof")) return "React.element";
                      return value;
                    });
                  }}
                />
              )}
            </StartupOperations>
          </AuthenticationCompontent>
        </LocalizationProvider>
      </ThemeProviderOO>
    </ColorModeContext.Provider>
  );
};

function App() {
  return (
    <RecoilRoot>
      <ApolloProvider client={client}>
        <CubeProvider cubeApi={cubejsApi}>
          <AppInner />
        </CubeProvider>
      </ApolloProvider>
    </RecoilRoot>
  );
}

export default App;
